var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column2-container"},[_c('TrajectoryDiagram',{attrs:{"trajectory":_vm.trajectory}}),_c('Order',{attrs:{"orderList":_vm.order}}),_c('MapHot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }